var _desc, _defs, _use, _path, _path2, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacbookCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "694px",
    height: "466px",
    viewBox: "0 0 694 466",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "107.956459%",
    y2: "99.2466518%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F4F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECBE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.628018296%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEBF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EABBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "107.600925%",
    y2: "98.9198023%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEAF5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CDD6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.333,0.5 C63.497,0.5 56.334,7.664 56.334,16.5 L56.334,16.5 L56.334,463.5 C56.334,469.575 61.258,474.5 67.333,474.5 L67.333,474.5 L737.333,474.5 C743.408,474.5 748.333,469.575 748.333,463.5 L748.333,463.5 L748.333,16.5 C748.333,7.664 741.17,0.5 732.334,0.5 L732.334,0.5 L72.333,0.5 Z",
    id: "path-4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2",
    transform: "translate(-55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "macbook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mockup",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-4"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-2)",
    strokeWidth: 3,
    d: "M72.333,2 C64.3256468,2 57.834,8.49220739 57.834,16.5 L57.834,463.5 C57.834,468.746806 62.08666,473 67.333,473 L737.333,473 C742.579573,473 746.833,468.746573 746.833,463.5 L746.833,16.5 C746.833,8.49220739 740.341353,2 732.334,2 L72.333,2 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2.5,
    d: "M72.333,1.75 C64.1875708,1.75 57.584,8.35414103 57.584,16.5 L57.584,463.5 C57.584,468.88487 61.9485818,473.25 67.333,473.25 L737.333,473.25 C742.717644,473.25 747.083,468.884644 747.083,463.5 L747.083,16.5 C747.083,8.35414103 740.479429,1.75 732.334,1.75 L72.333,1.75 Z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    strokeOpacity: 0.25,
    stroke: "#D1F9FF",
    strokeWidth: 1,
    xlinkHref: "#path-4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbookCover);
export default __webpack_public_path__ + "static/media/macbook-cover.fd4998bb40d5805d19e8c5cd350f6d41.svg";
export { ForwardRef as ReactComponent };